/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteStackRuleInput = {|
  stackId: string,
  clientMutationId?: ?string,
|};
export type DeleteStackRuleMutationVariables = {|
  input: DeleteStackRuleInput
|};
export type DeleteStackRuleMutationResponse = {|
  +deleteStackRule: ?{|
    +success: ?boolean
  |}
|};
export type DeleteStackRuleMutation = {|
  variables: DeleteStackRuleMutationVariables,
  response: DeleteStackRuleMutationResponse,
|};
*/


/*
mutation DeleteStackRuleMutation(
  $input: DeleteStackRuleInput!
) {
  deleteStackRule(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteStackRulePayload",
    "kind": "LinkedField",
    "name": "deleteStackRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteStackRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteStackRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f84bb9e0ba14dd66de7f937da256016f",
    "id": null,
    "metadata": {},
    "name": "DeleteStackRuleMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteStackRuleMutation(\n  $input: DeleteStackRuleInput!\n) {\n  deleteStackRule(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6e7827126cccc1666f616df52f69fd7d';

module.exports = node;
